
export default function (fieldImage, data, defaultImage, reuse) {

    return function deltaIndicator(params) {

        let imagePath = params.data[fieldImage];
        let { value } = params;

        const $element = document.createElement("div");
        const $logoContainer = document.createElement("div");
        const $imageContainer = document.createElement("div");
        const $imageElement = document.createElement("img");
        const $text = document.createElement('p');

        $element.classList.add('flex');
        $element.classList.add('items-center');

        $logoContainer.classList.add('con-vs-avatar');
        $logoContainer.classList.add('avatar-table');
        $logoContainer.classList.add('mr-4');

        $imageContainer.classList.add('con-img');
        $imageContainer.classList.add('vs-avatar--con-img');


        if (typeof fieldImage === 'function') {
            imagePath = fieldImage(params.data);
        }


        if (imagePath) {

            $imageElement.src = imagePath;
            $imageContainer.appendChild($imageElement);
            $logoContainer.appendChild($imageContainer);

        } else if (defaultImage) {

            $logoContainer.classList.add('no-image');
            $logoContainer.innerHTML = `
            <span
            translate="translate"
            class="vs-avatar--text feather ${defaultImage} text-xl"
            style="transform: translate(-50%, -50%) scale(1); color: rgb(255, 255, 255);">
            </span>
            `;

        } else {

            $logoContainer.classList.add('no-image');
            $logoContainer.innerHTML = `
                <span
                    translate="translate"
                    class="vs-avatar--text notranslate material-icons person material-icons"
                    style="transform: translate(-50%, -50%) scale(1); color: rgb(255, 255, 255);">
                    person
                </span>
            `;
        }

        if(data) {
            if (typeof data === 'function') {
                value = data(params.data);
            } else {
                value = params.data[data];
            }
        }

        $text.innerText = value;

        $element.appendChild($logoContainer);
        $element.appendChild($text);

        if (reuse) {
            return $element
        }

        return $element.outerHTML;
    }
}
